import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://bingo-backend-tn7s.onrender.com/api",
  withCredentials: true,
});

export default instance;